import Button from "../../Button";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import AddSvg from "../../../Svg/AddSvg";
import React, { useContext, useEffect } from "react";
import constants from "../../../constants";
import IconButton from "@mui/material/IconButton";
import PlayIconSvg from "../../../Svg/PlayIconSvg";
import ChevronUpSvg from "../../../Svg/ChevronUpSvg";
import CloseSvgIcon from "../../../Svg/CloseSvgIcon";
import GenerateQR from "../InstructionPage/GenerateQR";
import AlertContext from "../../../context/AlertContext";
import CodingOutputHooks from "../../../Hooks/CodingPage/CodingOutputHooks";
import { getDataFromStorage } from "../../../util";
import { useState } from "react";
export default function CodingOutput(Props) {
  const Alert = useContext(AlertContext);
  const [activeOutputTab, setActiveOutputTab] = React.useState("testcases");
  const CodingOutputHks = CodingOutputHooks();
  // const timeComplexityResult = Alert.timeComplexityResult;
  const [isValid, setIsValid] = useState(null);

  // const isTimeComplexityValid = Alert.timeComplexityResul?.syntax == "Valid";
  // const isTimeComplexityInvalid = Alert.timeComplexityResul?.syntax == "Invalid";

  Alert.testCasesRef.current.sort((testcase1, testcase2) => {
    const array1 = testcase1.isexample;
    const array2 = testcase2.isexample;

    return array1 - array2;
  });
  // console.log("value:", CodingOutputHks.value);
  useEffect(() => {
    setIsValid(Alert.timeComplexityResult?.syntax === "Valid" ? true : Alert.timeComplexityResult?.syntax === "Invalid" ? false : null);
  }, [Alert.timeComplexityResult]);
  useEffect(() => {
    // console.log("value:Output page", CodingOutputHks.value);
    // console.log("Alert.testCasesRef.current:", Alert.testCasesRef.current);
    if (
      Alert.testCasesRef.current[
        Alert.testCasesRef.current.length - 1
      ].hasOwnProperty("isSystemTestCase")
    ) {
      // console.log("not newly added or removed");
      CodingOutputHks.setValue(0);
    }
  }, [Alert.testCasesRef.current]);
  useEffect(() => {
    Alert.setTimeComplexityResult(null);
  }, []);
  // console.log("isTimeComplexityInvalid:",isTimeComplexityInvalid);
  return (
    <div className="codingOutputMainContainer">
      <div className="codingOutputHeader">
        <div className="codingOutputHeaderTitle">
          <Button
            size="sm"
            onClick={() => setActiveOutputTab("testcases")}
            hierarchy={{
              type:
                activeOutputTab === "testcases"
                  ? "secondaryColor"
                  : "tertiaryGrey",
              buttonText: "Testcases",
            }}
          />
          <Button
            size="sm"
            onClick={() => setActiveOutputTab("timeComplexity")}
            hierarchy={{
              type:
                activeOutputTab === "timeComplexity"
                  ? "secondaryColor"
                  : "tertiaryGrey",
              buttonText: "Time Complexity",
            }}
          />
        </div>
        <div
          className="codingOutputHeaderIcon"
          onClick={Props.toggleOutputWindowHeight}
        >
          <ChevronUpSvg />
        </div>
      </div>

      {activeOutputTab === "testcases" ? (
        <>
          {!Alert.testData.notebook && (
            <div className="codingOutputTestcasesDiv">
              <div className="codingOutputTestcasesDivBox">
                <Box
                  sx={{
                    overflowX: "auto",
                    bgcolor: "background.paper",
                    maxWidth: { xs: 320, sm: 900 },
                  }}
                >
                  <Tabs
                    variant="scrollable"
                    scrollButtons={false}
                    value={CodingOutputHks.value}
                    onChange={CodingOutputHks.handleTabChange}
                    className="codingOutputTestcasesDivBoxTab"
                    TabIndicatorProps={{ style: { display: "none" } }}
                  >
                    {Alert.testCasesRef.current.length > 0
                      ? Alert.testCasesRef.current.map((tab, index) => (
                        <Tab
                          key={index}
                          label={`Case ${index + 1}`}
                          className={CodingOutputHks.handleCodingOutputTestcasesBoxTab(
                            tab,
                            index
                          )}
                          icon={
                            index !== 0 &&
                            !tab.hasOwnProperty("isexample") && (
                              <IconButton
                                onClick={() =>
                                  CodingOutputHks.deleteTab(index)
                                }
                                className="codingOutputTestcasesBoxTabCloseSvgIcon"
                              >
                                <CloseSvgIcon component="codingOutput" />
                              </IconButton>
                            )
                          }
                        />
                      ))
                      : CodingOutputHks.addTab()}
                  </Tabs>
                </Box>
              </div>
              <div className="codingOutputTestcasesBoxTabAddSvgIcon">
                <IconButton onClick={CodingOutputHks.addTab}>
                  <AddSvg />
                </IconButton>
              </div>
            </div>
          )}

          <div className="codingOutputTestcasesContainer">
            {Alert.testCasesRef.current.length > 0 &&
              Alert.testCasesRef.current.map((tab, index) => (
                <React.Fragment key={tab.id || index}>
                  <div
                    hidden={CodingOutputHks.value !== index}
                    className="codingOutputTestcasesInputContainer"
                  >
                    {!Alert.testData.notebook && (
                      <div className="codingOutputTestcasesInnerInputContainer">
                        {tab.input.split("\n").map((input, ipIndex) => {
                          if (!input.trim() && !tab.iscustom) return null;

                          return (
                            <div
                              key={ipIndex}
                              className="codingOutputTestcasesInnerInputContainerDiv"
                            >
                              <label className="codingOutputTestcasesInputVariable">
                                {Alert.isInputVariable.current
                                  ? Alert.inputVariable[ipIndex] + " : "
                                  : "Input " + (ipIndex + 1) + ""}
                              </label>
                              <input
                                type="text"
                                value={input === "false" ? "" : input}
                                disabled={tab.hasOwnProperty("isexample")}
                                className="codingOutputTestcasesInputValue"
                                onChange={(event) =>
                                  CodingOutputHks.handleTestCaseInputChange(
                                    event,
                                    tab.id,
                                    ipIndex
                                  )
                                }
                              />
                            </div>
                          );
                        })}
                      </div>
                    )}
                    <div className="codingOutputTestcasesOutputContainer">
                      <div className="codingOutputTestcasesActualOutputContainerDiv">
                        <label
                          htmlFor="codingOutputTestcasesActualOutput"
                          className="codingOutputTestcasesActualOutputName"
                        >
                          {!Alert.testData.notebook &&
                            !Alert.codeDetails.istestcases &&
                            "Actual"}{" "}
                          Output
                        </label>
                        <div className="codingOutputTestcasesActualOutputValue">
                          {typeof tab.actualoutput === "string"
                            ? tab.actualoutput
                            : JSON.stringify(tab.actualoutput)}
                        </div>
                      </div>
                      {!Alert.testData.notebook &&
                        !Alert.codeDetails.istestcases && (
                          <div className="codingOutputTestcasesExpectedOutputContainerDiv">
                            <label
                              htmlFor="codingOutputTestcasesExpectedOutput"
                              className="codingOutputTestcasesExpectedOutputName"
                            >
                              Expected Output
                            </label>
                            <div className="codingOutputTestcasesExpectedOutputValue">
                              {typeof tab.output === "string"
                                ? tab.output
                                : JSON.stringify(tab.output)}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                </React.Fragment>
              ))}
            <div className="codingOutputButtonDiv">
              <Button
                size={"md"}
                onClick={CodingOutputHks.handleRunCurrentTestCase}
                icon={{ type: "leading", icon: <PlayIconSvg /> }}
                hierarchy={{
                  buttonText: "Run",
                  type: "secondaryColor",
                }}
              />
            </div>
            {/* {Alert.testData.testmode === constants.MODE.TEST_MODE &&
              Alert.status !== constants.QUESTION_STATUS.SUBMITTED && (
                <GenerateQR />
              )} */}
          </div>
        </>
      ) : (
        <div className="codingOutputTimeComplexityContainer">
          {isValid  ? (
            <div className="codingOutputTimeComplexityResult codingOutputTimeComplexityResultSuccess">
              <p className="codingOutputTimeComplexityTitle">
                Time Complexity Analyzed
              </p>
              <p className="codingOutputTimeComplexityMessage">
                Your code has been analyzed successfully.
              </p>
              <div className="codingOutputTimeComplexityValueRow">
                <div className="codingOutputTimeComplexityLabel">
                  Estimated Time Complexity
                </div>
                <span className="codingOutputTimeComplexityValue">
                  {Alert.timeComplexityResult?.timeComplexity}
                </span>
              </div>
              {Alert.timeComplexityResult?.solutionComplexity && (
                <div className="codingOutputTimeComplexityValueRow">
                  <div className="codingOutputTimeComplexityLabel">
                    System's Time Complexity
                  </div>
                  <span className="codingOutputTimeComplexityValue">
                    {Alert.timeComplexityResult?.solutionComplexity?.timeComplexity || "-"}                </span>
                </div>
              )}
            </div>
          ) : isValid == false ? (
            <div className="codingOutputTimeComplexityResult codingOutputTimeComplexityResultError">
              <p className="codingOutputTimeComplexityTitle">Unable to Analyze</p>
              <p className="codingOutputTimeComplexityMessage">
                Time Complexity could not be calculated because the code executed failed.
              </p>
              <p className="codingOutputTimeComplexityReasonTitle">Reasons</p>
              <ul className="codingOutputTimeComplexityReasons">
                <li>{Alert.timeComplexityResult.error ?? "Unknown error"}</li>
              </ul>
            </div>
          ) : (
            <div className="codingOutputTimeComplexityEmpty">
              Run your code to view time complexity analysis.
            </div>
          )}
        </div>

      )}
    </div>
  );
}
